module.exports = __webpack_public_path__ + "assets/img/202108-3W.a017c6c7.png";